/* Ports the mobile menu drawer behavior from Nav.tsx. */
(function () {
  "use strict";
  function $(s) { return document.querySelector(s); }

  function init() {
    var overlay = $("[data-menu-overlay]");
    var panel = $("[data-menu-panel]");
    if (!panel) return;

    function open() {
      overlay.classList.remove("pointer-events-none", "opacity-0");
      overlay.classList.add("opacity-100");
      panel.classList.remove("-translate-x-full");
      panel.classList.add("translate-x-0");
      document.body.style.overflow = "hidden";
    }
    function close() {
      overlay.classList.add("pointer-events-none", "opacity-0");
      overlay.classList.remove("opacity-100");
      panel.classList.add("-translate-x-full");
      panel.classList.remove("translate-x-0");
      document.body.style.overflow = "";
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-menu-open]")) { e.preventDefault(); open(); return; }
      if (e.target.closest("[data-menu-close]")) { close(); return; }
      if (e.target === overlay) { close(); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
